import { render, staticRenderFns } from "./RoleProductTaxonomy.vue?vue&type=template&id=0ae93aaa&scoped=true"
import script from "./RoleProductTaxonomy.vue?vue&type=script&lang=js"
export * from "./RoleProductTaxonomy.vue?vue&type=script&lang=js"
import style0 from "./RoleProductTaxonomy.vue?vue&type=style&index=0&id=0ae93aaa&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae93aaa",
  null
  
)

export default component.exports